import React from "react";
import girls  from "../../assets/girls.png";
import child from "../../assets/child.png";
import "./Story.css"; 
import { useNavigate } from "react-router-dom";

const StoriesOfImpact = () => {
  const navigate = useNavigate();
  return (
    <div className="story">
      <h1>STORIES OF IMPACT</h1>
      <div className="story-container">
        <div className="story-left">
          <p>
            NEW DELHI: On a sultry May afternoon, 14-year-old Naaz Parveen
            stands with a notebook and a pen in her hands in the narrow lanes of
            Delhi’s Valmiki Lane. Like other kids her age, she has come back
            from school, where she attends classes on maths, science,
            languages, desh bhakti, and happiness. However, unlike them, she
            changes her uniform, and takes on a new avatar: that of a reporter
            with Balaknama, the world’s first newspaper run by street children,
            which highlights the issues faced by them.Parveen is one of the ten
            main reporters with the newspaper, which has published 112 editions
            so far. Each edition carries about 40 news articles, written in
            Hindi, and some translated into English as well. About 90 other
            reporters spread across north India contribute inputs orally, which
            are written down by Parveen among others. Childhood Enhancement
            through Training and Action (CHETNA), a Delhi-based NGO, has been
            mentoring the newspaper’s run since 2003. About 10,000 copies of
            the newspaper are circulated, and many of them reach the homes of
            street children.
          </p>
          <img src={girls} alt="Girls"/>
        </div>

        {/* Right Story Section */}
        <div className="story-right">
          <p>
            Child Labour - As per Census 2011, the total child population in
            India in the age group (5-14) years is 259.6 million. Of these, 10.1
            million (3.9% of total child population) are working, either as
            ‘main worker’ or as ‘marginal worker’. In addition, more than 42.7
            million children in India are out of school. However, the good news
            is that the incidence of child labour has decreased in India by 2.6
            million between 2001 and 2011. However, the decline was more visible
            in rural areas, while the number of child workers has increased in
            urban areas, indicating the growing demand for child workers in
            menial jobs. Child labour has different ramifications in both rural
            and urban India. Analyses of data from PLFS 2018/19 conducted as
            part of this report reveal that the estimated number of children in
            child labour in India ranged from 1.8 million (0.7 per cent of all
            children aged 5–17 years) using the national definition to 3.3
            million (1.3 per cent of children).
          </p>
          <img src={child} alt="Child labour" />
        </div>
      </div>

      {/* Button Section */}
      {/* <div className="story-btn">
        <button className="donate-btn" onClick={() => navigate('/stories-of-change')}>STORIES OF CHANGE</button>
      </div> */}
    </div>
  );  
};

export default StoriesOfImpact;
